import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  askDelete: {
    id: `app.containers.WorkflowEditor.components.AddItemRows.ItemRow.askDelete`,
    defaultMessage: 'Are you sure you want to delete?',
  },
});
